import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { financecommerceApi, type JournalVoucher } from '../../api/financecommerce';

export function AccountingDashboardPage() {
  const [journals, setJournals] = useState<JournalVoucher[]>([]);

  useEffect(() => {
    void financecommerceApi.listJournals().then(setJournals);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/finance" className="text-sm text-slate-600 hover:underline">← Finance hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Accounting dashboard</h1>
      <ul className="mt-6 space-y-2 text-sm">
        {journals.map((j) => (
          <li key={j.id} className="rounded border p-3">{j.voucher_number} — {j.status} · Dr/Cr {j.total_debit}</li>
        ))}
        {!journals.length && <li className="text-slate-500">No journals — process a settlement first</li>}
      </ul>
    </div>
  );
}
